import axios from '@/axios';

export default {
  getBrandAll(_context, data){
    return new Promise((resolve, reject) => {
      axios
        .get('/api/v1/clinics/non-auth/brands', { params: data })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  getBrandList(_context, data){
    return new Promise((resolve, reject) => {
      axios
        .get('/api/v1/admins/brand/all', { params: data })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  getPopularBrands() {
    return new Promise((resolve, reject) => {
      axios
      .get('/api/v1/admins/brands/popular')
        .then(res => {
          return resolve(res);
        })
        .catch(err => {
          return reject(err);
        });
    });
  },
  deleteBrandById(_context, id) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/v1/admins/brand/${id}`)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  createBrand(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/v1/admins/brand/create', data)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  getBrandDetailsBySlug(_context, slug) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/v1/admins/brand/slug/${slug}`)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  getBrandDetails(_context, id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/v1/admins/brand/${id}`)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  updateBrandDetails(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .put(`/api/v1/admins/brand/${data.id}`, data.info)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  getBrandProductList(_context, { id, dataTableParams }) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/v1/admins/brand/${id}/products`, { params: dataTableParams })
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  getBrandProductListBySlug(_context,  fitlerParams ) {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/v1/clinics/products-by-brand', { params: fitlerParams })
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  removeProductFromBrand(_context, id) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/v1/admins/brand/remove/${id}/product`)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
};
